import addressesFromComponentDeliveryDetailsPreload from '@/composables/preLoad/addressesFromComponentDeliveryDetailsPreload'
import use417Preload from '@/composables/preLoad/establishment/use417Preload'
import use920Preload from '@/composables/preLoad/establishment/use920Preload'
import use922Preload from '@/composables/preLoad/establishment/use922Preload'
import useEstablishmentPreload from '@/composables/preLoad/establishment/useBasePreload.js'
import useCancelSubscriptionPreload from '@/composables/preLoad/establishment/useCancelSubscriptionPreload'
import useFreezonePreload from '@/composables/preLoad/establishment/useFreezonePreload.js'
import use583Preload from '@/composables/preLoad/familyBook/use583Preload.js'
import use587Preload from '@/composables/preLoad/familyBook/use587Preload.js'
import use593Preload from '@/composables/preLoad/familyBook/use593Preload.js'
import use595Preload from '@/composables/preLoad/familyBook/use595Preload.js'
import use713Preload from '@/composables/preLoad/familyBook/use713Preload.js'
import use730Preload from '@/composables/preLoad/familyBook/use730Preload.js'
import use733Preload from '@/composables/preLoad/familyBook/use733Preload.js'
import use761Preload from '@/composables/preLoad/familyBook/use761Preload.js'
import use762Preload from '@/composables/preLoad/familyBook/use762Preload.js'
import use766Preload from '@/composables/preLoad/familyBook/use766Preload.js'
import use827Preload from '@/composables/preLoad/familyBook/use827Preload.js'
import use407Preload from '@/composables/preLoad/fines/use407Preload.js'
import use573Preload from '@/composables/preLoad/gccCitizens/use573Preload'
import use585Preload from '@/composables/preLoad/NewbornRegistertionRequest/use585Preload.js'
import use411Preload from '@/composables/preLoad/sponsorFile/use411Preload'
import use1040Preload from '@/composables/preLoad/use1040Preload.js'
import use1058Preload from '@/composables/preLoad/use1058Preload.js'
import use121Preload from '@/composables/preLoad/use121Preload.js'
import use140Preload from '@/composables/preLoad/use140Preload'
import use148Preload from '@/composables/preLoad/use148Preload.js'
import use165Preload from '@/composables/preLoad/use165Preload'
import use187Preload from '@/composables/preLoad/use187Preload.js'
import use206Preload from '@/composables/preLoad/use206Preload.js'
import use212Preload from '@/composables/preLoad/use212Preload.js'
import use369Preload from '@/composables/preLoad/use369Preload.js'
import use375Preload from '@/composables/preLoad/use375Preload.js'
import use401Preload from '@/composables/preLoad/use401Preload.js'
import use412Preload from '@/composables/preLoad/use412Preload.js'
import use445Preload from '@/composables/preLoad/use445Preload.js'
import use446Preload from '@/composables/preLoad/use446Preload.js'
import use458Preload from '@/composables/preLoad/use458Preload.js'
import use481Preload from '@/composables/preLoad/use481Preload.js'
import use490Preload from '@/composables/preLoad/use490Preload.js'
import use495Preload from '@/composables/preLoad/use495Preload.js'
import use561Preload from '@/composables/preLoad/use561Preload.js'
import use663Preload from '@/composables/preLoad/use663Preload.js'
import use693Preload from '@/composables/preLoad/use693Preload.js'
import use714Preload from '@/composables/preLoad/use714Preload.js'
import use719Preload from '@/composables/preLoad/use719Preload.js'
import use739Preload from '@/composables/preLoad/use739Preload.js'
import use767Preload from '@/composables/preLoad/use767Preload.js'
import use79Preload from '@/composables/preLoad/use79Preload.js'
import use838Preload from '@/composables/preLoad/use838Preload.js'
import use903Preload from '@/composables/preLoad/use903Preload.js'
import use92Preload from '@/composables/preLoad/use92Preload.js'
import use996Preload from '@/composables/preLoad/use996Preload.js'
import use184Preload from '@/composables/preLoad/use184Preload.js'
import use192Preload from '@/composables/preLoad/use192Preload.js'
import use477Preload from '@/composables/preLoad/use477Preload.js'
import use430Preload from '@/composables/preLoad/use430Preload.js'
import use433Preload from '@/composables/preLoad/use433Preload.js'
import use682Preload from '@/composables/preLoad/use682Preload.js'
import use905Preload from '@/composables/preLoad/use905Preload.js'
import use599Preload from '@/composables/preLoad/use599Preload.js'
import useTypingCenterResidencyPreload from '@/composables/preLoad/useTypingCenterResidencyPreload.js'
import useTypingCenterVisaPreload from '@/composables/preLoad/useTypingCenterVisaPreload.js'
import useIcaidaFormPreload from '@/composables/preLoad/useIcaidaFormPreload.js'
import useIcaUnifiedFormPreload from '@/composables/preLoad/useIcaUnifiedFormPreload.js'
import useIssueVisaPreload from '@/composables/preLoad/useIssueVisaPreload.js'
import useResidencyPreload from '@/composables/preLoad/useResidencyPreload.js'
import useCancelResidencyPreload from '@/composables/preLoad/useCancelResidencyPreload.js'
import useSetVisitReasonForTruckDrivers from '@/composables/preLoad/useSetVisitReasonForTruckDrivers.js'
import useVisaPreload from '@/composables/preLoad/useVisaPreload.js'
import use575Preload from '@/composables/preLoad/gccCitizens/use575Preload.js'
import useGccVisaPreload from '@/composables/preLoad/useGccVisaPreload.js'
import use109Preload from '@/composables/preLoad/use109Preload.js'
import { useAuthStore } from '@/stores/auth'

export default async function (serviceId) {
  const authStore = useAuthStore()
  const NewbornRegistertionRequest = {
    585: use585Preload
  }
  const reportsPreloads = {
    446: use446Preload,
    447: use446Preload,
    607: use446Preload
  }
  const familyBookPreloads = {
    582: use587Preload,
    583: use583Preload,
    587: use587Preload,
    593: use593Preload,
    595: use595Preload,
    713: use713Preload,
    719: use719Preload,
    730: use730Preload,
    731: use730Preload,
    733: use733Preload,
    732: use730Preload,
    734: use730Preload,
    761: use761Preload,
    762: use762Preload,
    766: use766Preload,
    827: use827Preload
  }

  const issueVisaPreloads = {
    432: useIssueVisaPreload,
    763: useIssueVisaPreload,
    783: useIssueVisaPreload,
    784: useIssueVisaPreload,
    939: useIssueVisaPreload,
    941: useIssueVisaPreload,
    942: useIssueVisaPreload,
    944: useIssueVisaPreload,
    945: useIssueVisaPreload,
    946: useIssueVisaPreload,
    962: useIssueVisaPreload
  }

  const visaPreloads = {
    37: useVisaPreload,
    413: useVisaPreload,
    995: useVisaPreload,
    632: useVisaPreload,
    633: useVisaPreload,
    635: useVisaPreload,
    636: useVisaPreload,
    639: useVisaPreload,
    753: useVisaPreload,
    926: useVisaPreload,
    928: useVisaPreload,
    933: useVisaPreload,
    950: useVisaPreload,
    951: useVisaPreload,
    952: useVisaPreload,
    1005: useVisaPreload,
    1006: useVisaPreload,
    1007: useVisaPreload,
    1008: useVisaPreload,
    1009: useVisaPreload,
    1010: useVisaPreload,
    1104: useVisaPreload,
    1105: useVisaPreload
  }

  const sponsorFile = {
    411: use411Preload,
    564: use411Preload,
    565: use411Preload,
    434: use411Preload,
    435: use411Preload
  }
  const gccPreloads = {
    41: useGccVisaPreload,
    42: useGccVisaPreload,
    377: useGccVisaPreload
  }
  const establishmentPreloads = {
    4: useEstablishmentPreload,
    8: useEstablishmentPreload,
    10: useEstablishmentPreload,
    15: useEstablishmentPreload,
    17: useEstablishmentPreload,
    25: useEstablishmentPreload,
    46: useEstablishmentPreload,
    47: useEstablishmentPreload,
    48: useEstablishmentPreload,
    49: useEstablishmentPreload,
    29: useEstablishmentPreload,
    33: useEstablishmentPreload,
    34: useEstablishmentPreload,
    42: useEstablishmentPreload,
    80: useEstablishmentPreload,
    110: useEstablishmentPreload,
    111: useEstablishmentPreload,
    112: useEstablishmentPreload,
    118: useEstablishmentPreload,
    142: useEstablishmentPreload,
    149: useEstablishmentPreload,
    156: useEstablishmentPreload,
    157: useEstablishmentPreload,
    158: useEstablishmentPreload,
    160: useEstablishmentPreload,
    162: useEstablishmentPreload,
    343: useEstablishmentPreload,
    344: useEstablishmentPreload,
    345: useEstablishmentPreload,
    363: useEstablishmentPreload,
    364: useEstablishmentPreload,
    365: useEstablishmentPreload,
    380: useEstablishmentPreload,
    393: useEstablishmentPreload,
    413: useEstablishmentPreload,
    417: use417Preload,
    440: useEstablishmentPreload,
    453: useEstablishmentPreload,
    458: useEstablishmentPreload,
    459: useEstablishmentPreload,
    460: useCancelSubscriptionPreload,
    461: useCancelSubscriptionPreload,
    463: useEstablishmentPreload,
    477: useEstablishmentPreload,
    481: use481Preload,
    482: useEstablishmentPreload,
    483: useEstablishmentPreload,
    518: useEstablishmentPreload,
    637: useEstablishmentPreload,
    651: useEstablishmentPreload,
    652: useEstablishmentPreload,
    653: useEstablishmentPreload,
    654: useEstablishmentPreload,
    655: useEstablishmentPreload,
    691: useEstablishmentPreload,
    727: useEstablishmentPreload,
    744: useEstablishmentPreload,
    745: useEstablishmentPreload,
    748: useEstablishmentPreload,
    749: useEstablishmentPreload,
    750: useEstablishmentPreload,
    836: useEstablishmentPreload,
    870: useEstablishmentPreload,
    917: useEstablishmentPreload,
    919: useEstablishmentPreload,
    920: use920Preload,
    922: use922Preload,
    770: useEstablishmentPreload,
    783: useEstablishmentPreload,
    784: useEstablishmentPreload,
    835: useEstablishmentPreload,
    837: useEstablishmentPreload,
    918: useEstablishmentPreload,
    936: useEstablishmentPreload,
    949: useEstablishmentPreload,
    960: useEstablishmentPreload,
    961: useEstablishmentPreload,
    1049: useEstablishmentPreload,
    1052: useEstablishmentPreload,
    1090: useEstablishmentPreload,
    1120: useEstablishmentPreload,
    1021: useFreezonePreload,
    1059: useFreezonePreload
  }

  const residency = {
    70: useResidencyPreload,
    71: useResidencyPreload,
    121: use121Preload,
    122: useResidencyPreload,
    406: useResidencyPreload,
    443: useResidencyPreload,
    993: useResidencyPreload
  }

  const gccCitizensPreload = {
    573: use573Preload,
    574: use573Preload,
    575: use575Preload
  }

  const fines = {
    407: use407Preload
  }
  const icaServices = {
    92: use92Preload,
    401: use401Preload,
    502: useIcaUnifiedFormPreload,
    503: useIcaUnifiedFormPreload,
    556: useIcaUnifiedFormPreload,
    900: useIcaUnifiedFormPreload,
    571: useIcaidaFormPreload,
    572: useIcaidaFormPreload,
    580: useIcaidaFormPreload
  }

  const courtRequest = {
    206: use206Preload,
    207: use206Preload,
    208: use206Preload,
    209: use206Preload
  }
  const investigation = {
    212: use212Preload,
    495: use495Preload
  }

  const truckDriversServices = {
    967: useSetVisitReasonForTruckDrivers,
    968: useSetVisitReasonForTruckDrivers,
    969: useSetVisitReasonForTruckDrivers
  }

  const typingCenter = {
    109: use109Preload,
    114: use109Preload,
    115: use109Preload,
    119: use109Preload,
    184: use184Preload,
    185: use184Preload,
    200: use184Preload,
    201: use184Preload,
    202: use184Preload,
    203: use184Preload,
    409: use184Preload,
    410: use184Preload,
    212: use477Preload,
    418: use477Preload,
    477: use477Preload,
    192: use192Preload,
    193: use192Preload,
    430: use430Preload,
    433: use433Preload,
    682: use682Preload,
    905: use905Preload,
    1028: use905Preload,
    1029: use905Preload,
    1030: use905Preload,
    160: use140Preload,

    599: use599Preload,
    1112: use599Preload,
    1113: use599Preload,
    600: use599Preload,
    601: use599Preload,
    602: use599Preload,
    613: use599Preload,
    754: use599Preload,

    406: useCancelResidencyPreload,
    443: useCancelResidencyPreload,
    445: useCancelResidencyPreload,

    57: useTypingCenterResidencyPreload,
    58: useTypingCenterResidencyPreload,
    69: useTypingCenterResidencyPreload,
    70: useTypingCenterResidencyPreload,
    71: useTypingCenterResidencyPreload,
    89: useTypingCenterResidencyPreload,
    120: useTypingCenterResidencyPreload,
    121: useTypingCenterResidencyPreload,
    122: useTypingCenterResidencyPreload,
    400: useTypingCenterResidencyPreload,
    423: useTypingCenterResidencyPreload,
    437: useTypingCenterResidencyPreload,
    438: useTypingCenterResidencyPreload,
    567: useTypingCenterResidencyPreload,
    569: useTypingCenterResidencyPreload,
    641: useTypingCenterResidencyPreload,
    656: useTypingCenterResidencyPreload,
    657: useTypingCenterResidencyPreload,
    658: useTypingCenterResidencyPreload,
    659: useTypingCenterResidencyPreload,
    662: useTypingCenterResidencyPreload,
    665: useTypingCenterResidencyPreload,
    667: useTypingCenterResidencyPreload,
    668: useTypingCenterResidencyPreload,
    676: useTypingCenterResidencyPreload,
    677: useTypingCenterResidencyPreload,
    679: useTypingCenterResidencyPreload,
    680: useTypingCenterResidencyPreload,
    681: useTypingCenterResidencyPreload,
    685: useTypingCenterResidencyPreload,
    686: useTypingCenterResidencyPreload,
    687: useTypingCenterResidencyPreload,
    688: useTypingCenterResidencyPreload,
    689: useTypingCenterResidencyPreload,
    690: useTypingCenterResidencyPreload,
    758: useTypingCenterResidencyPreload,
    759: useTypingCenterResidencyPreload,
    760: useTypingCenterResidencyPreload,
    769: useTypingCenterResidencyPreload,
    771: useTypingCenterResidencyPreload,
    773: useTypingCenterResidencyPreload,
    774: useTypingCenterResidencyPreload,
    775: useTypingCenterResidencyPreload,
    776: useTypingCenterResidencyPreload,
    777: useTypingCenterResidencyPreload,
    778: useTypingCenterResidencyPreload,
    820: useTypingCenterResidencyPreload,
    916: useTypingCenterResidencyPreload,
    935: useTypingCenterResidencyPreload,
    938: useTypingCenterResidencyPreload,
    943: useTypingCenterResidencyPreload,
    948: useTypingCenterResidencyPreload,
    955: useTypingCenterResidencyPreload,
    959: useTypingCenterResidencyPreload,
    980: useTypingCenterResidencyPreload,
    981: useTypingCenterResidencyPreload,
    982: useTypingCenterResidencyPreload,
    985: useTypingCenterResidencyPreload,
    987: useTypingCenterResidencyPreload,
    989: useTypingCenterResidencyPreload,
    991: useTypingCenterResidencyPreload,
    993: useTypingCenterResidencyPreload,
    1018: useTypingCenterResidencyPreload,
    1023: useTypingCenterResidencyPreload,
    1026: useTypingCenterResidencyPreload,
    1031: useTypingCenterResidencyPreload,
    1033: useTypingCenterResidencyPreload,
    1035: useTypingCenterResidencyPreload,
    1042: useTypingCenterResidencyPreload,
    1044: useTypingCenterResidencyPreload,
    1055: useTypingCenterResidencyPreload,
    1062: useTypingCenterResidencyPreload,
    1093: useTypingCenterResidencyPreload,
    1095: useTypingCenterResidencyPreload,
    1097: useTypingCenterResidencyPreload,
    1100: useTypingCenterResidencyPreload,
    1102: useTypingCenterResidencyPreload,
    1106: useTypingCenterResidencyPreload,
    1108: useTypingCenterResidencyPreload,
    1110: useTypingCenterResidencyPreload,
    1116: useTypingCenterResidencyPreload,
    1123: useTypingCenterResidencyPreload,
    1125: useTypingCenterResidencyPreload,
    1127: useTypingCenterResidencyPreload,

    24: useTypingCenterVisaPreload,
    26: useTypingCenterVisaPreload,
    27: useTypingCenterVisaPreload,
    28: useTypingCenterVisaPreload,
    36: useTypingCenterVisaPreload,
    37: useTypingCenterVisaPreload,
    38: useTypingCenterVisaPreload,
    40: useTypingCenterVisaPreload,
    43: useTypingCenterVisaPreload,
    47: useTypingCenterVisaPreload,
    48: useTypingCenterVisaPreload,
    50: useTypingCenterVisaPreload,
    51: useTypingCenterVisaPreload,
    52: useTypingCenterVisaPreload,
    53: useTypingCenterVisaPreload,
    54: useTypingCenterVisaPreload,
    383: useTypingCenterVisaPreload,
    385: useTypingCenterVisaPreload,
    386: useTypingCenterVisaPreload,
    387: useTypingCenterVisaPreload,
    413: useTypingCenterVisaPreload,
    414: useTypingCenterVisaPreload,
    420: useTypingCenterVisaPreload,
    436: useTypingCenterVisaPreload,
    490: useTypingCenterVisaPreload,
    632: useTypingCenterVisaPreload,
    633: useTypingCenterVisaPreload,
    635: useTypingCenterVisaPreload,
    636: useTypingCenterVisaPreload,
    639: useTypingCenterVisaPreload,
    642: useTypingCenterVisaPreload,
    644: useTypingCenterVisaPreload,
    645: useTypingCenterVisaPreload,
    646: useTypingCenterVisaPreload,
    647: useTypingCenterVisaPreload,
    648: useTypingCenterVisaPreload,
    664: useTypingCenterVisaPreload,
    666: useTypingCenterVisaPreload,
    678: useTypingCenterVisaPreload,
    753: useTypingCenterVisaPreload,
    755: useTypingCenterVisaPreload,
    757: useTypingCenterVisaPreload,
    763: useTypingCenterVisaPreload,
    764: useTypingCenterVisaPreload,
    785: useTypingCenterVisaPreload,
    926: useTypingCenterVisaPreload,
    928: useTypingCenterVisaPreload,
    933: useTypingCenterVisaPreload,
    950: useTypingCenterVisaPreload,
    951: useTypingCenterVisaPreload,
    952: useTypingCenterVisaPreload,
    963: useTypingCenterVisaPreload,
    964: useTypingCenterVisaPreload,
    965: useTypingCenterVisaPreload,
    973: useTypingCenterVisaPreload,
    976: useTypingCenterVisaPreload,
    977: useTypingCenterVisaPreload,
    978: useTypingCenterVisaPreload,
    994: useTypingCenterVisaPreload,
    995: useTypingCenterVisaPreload,
    1005: useTypingCenterVisaPreload,
    1006: useTypingCenterVisaPreload,
    1007: useTypingCenterVisaPreload,
    1008: useTypingCenterVisaPreload,
    1009: useTypingCenterVisaPreload,
    1041: useTypingCenterVisaPreload,
    1092: useTypingCenterVisaPreload,
    1099: useTypingCenterVisaPreload,
    1104: useTypingCenterVisaPreload,
    1105: useTypingCenterVisaPreload,
    1118: useTypingCenterVisaPreload
  }

  const mapping = {
    78: use79Preload,
    79: use79Preload,
    424: use79Preload,
    1057: use79Preload,
    187: use187Preload,
    458: use458Preload,
    412: use412Preload,
    767: use767Preload,
    733: use733Preload,
    739: use739Preload,
    996: use996Preload,
    663: use663Preload,
    903: use903Preload,
    1058: use1058Preload,
    148: use148Preload,
    693: use693Preload,
    714: use714Preload,
    139: use140Preload,
    140: use140Preload,
    141: use140Preload,
    165: use165Preload,
    375: use375Preload,
    838: use838Preload,
    445: use445Preload,
    490: use490Preload,
    561: use561Preload,
    369: use369Preload,
    1040: use1040Preload,
    ...icaServices,
    ...NewbornRegistertionRequest,
    ...reportsPreloads,
    ...issueVisaPreloads,
    ...familyBookPreloads,
    ...visaPreloads,
    ...sponsorFile,
    ...(authStore.isUserEstablishment && establishmentPreloads),
    ...residency,
    ...fines,
    ...gccCitizensPreload,
    ...courtRequest,
    ...investigation,
    ...truckDriversServices,
    ...gccPreloads,
    ...(authStore.isUserTypingCenter && typingCenter)
  }

  if (
    Object.keys(mapping)
      .map((m) => +m)
      .includes(serviceId)
  ) {
    await addressesFromComponentDeliveryDetailsPreload()
    return await mapping[serviceId]()
  }

  console.info(`[usePreloadMapping] There's no preload mapped for ${serviceId}`)
  return Promise.resolve(null)
}
